<template>
  <v-tooltip
    :disabled="hasTextKindImage"
    location="bottom"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props">
        <v-select
          v-model="selectedSource"
          variant="outlined"
          density="compact"
          hide-details
          :label="$t('buttons.content-creator.image-source')"
          validate-on="blur"
          :items="imageSourceItems"
          :menu-props="{ maxHeight: '1200px' }"
          item-title="text"
          item-value="value"
          data-product-fruits="content-creator-image-source"
          data-testid="content-creator-image-source-select"
          :disabled="isLoading || !hasTextKindImage"
          @update:model-value="handleImageSourceChange"
          @click="this.$tracking.event('Content Creator', 'Clicked', 'ImageSource')"
        >
          <template #selection="{ item }">
            <div class="d-flex align-center text-truncate selection-label">
              <v-icon>
                {{ item.raw.icon }}
              </v-icon>
              <span class="ml-3">{{ item.raw.text }}</span>
            </div>
          </template>

          <template #item="{ item, props }">
            <v-list-item
              :disabled="item.raw?.disabled"
              v-bind="!item.raw.needsUpgrade ? props : {}"
              @click="item.raw.needsUpgrade && upgrade()"
            >
              <template #prepend>
                <v-icon>
                  {{ item.raw.icon }}
                </v-icon>
              </template>

              <template #title>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </template>

              <template
                #subtitle
                v-if="item.raw.needsUpgrade"
              >
                <v-list-item-subtitle class="needs-upgrade-subtitle">
                  {{ $t('content-creator.text-kind-upgrade') }}
                </v-list-item-subtitle>
              </template>

              <template
                #append
                v-if="item.raw.needsUpgrade"
              >
                <v-icon> mdi-one-up </v-icon>
              </template>
            </v-list-item>
          </template>
        </v-select>
      </div>
    </template>
    <span>{{ $t('content-creator.tooltip.no-image-for-text-kind') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'ImageSourceSelect',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    imageSourceItems: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hasTextKindImage: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:modelValue', 'upgrade'],
  computed: {
    selectedSource: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },
  methods: {
    upgrade() {
      this.$emit('upgrade')
    },
    handleImageSourceChange(value) {
      this.$tracking.event('Content Creator', 'Selected', 'ImageSource')
      this.$tracking.heapEvent('image_source_selected', { image_source: value })
    },
  },
}
</script>

<style scoped>
@media (max-width: 600px) {
  .v-overlay__content {
    left: 8px !important;
  }
}
</style>
